import ActionTypes from './actionTypes';
import { ActionLoginToCheckoutResponses } from './apiResponses';
import CancelationReasons from '@sunbit-dev/common/enums/CancelationReasons';
import { Errors as ErrorCodes } from '../enums/Errors';

const phoneNumber = '855.778.6248';

export const errors = {
  [ActionTypes.ExtraVerification]: {
    [ErrorCodes.manualExtraVerificationFallback]: {
      isModal: true,
      title: 'Technical error',
      description: `Due to a technical error, your application could not be processed. You will receive an email with additional details on how to proceed.\n\nPlease contact Customer Support at 855-778-6248 with any questions.`,
      buttonTitle: 'OK',
      cancelApplication: true,
    },
  },
  [ActionTypes.ActionLoginToCheckout]: {
    [ActionLoginToCheckoutResponses['phoneNumberInvalid']]: {
      isModal: false,
    },
    [ActionLoginToCheckoutResponses['verificationCodeNeeded']]: {
      isModal: false,
    },
    [ActionLoginToCheckoutResponses['wrongCode']]: {
      isModal: false,
    },
    [ActionLoginToCheckoutResponses['alreadyVerified']]: {
      isModal: true,
      title: 'Phone Number is part of another active session',
      description: `Sorry, it looks like this number is already verified in another session, if that problems continue feel free to reach us at - ${phoneNumber}`,
      buttonTitle: 'OK',
    },
    [ActionLoginToCheckoutResponses['phoneNumberNotMatching']]: {
      isModal: true,
      title: 'Phone Number Error',
      description: 'The provided phone number does not match the customer’s phone number. Please contact your store or representative for support.',
      buttonTitle: 'OK',
    },
    [ActionLoginToCheckoutResponses['exceededVerificationAttempts']]: {
      isModal: true,
      description: 'Due to multiple unsuccessful attempts your application will restart.',
      buttonTitle: 'Close',
    },
    [ActionLoginToCheckoutResponses['expiredCode']]: {
      isModal: false,
      description: "Verification code is expired or doesn't exist for this phone number.",
      buttonTitle: 'Close',
    },
  },
  [ActionTypes.ActionCreateCheckoutCustomer]: {
    ErrorEmail: {
      isModal: true,
      title: 'Duplicate Email Address',
      description: 'The email address you entered is already being used by a different customer. Please enter a different email address.',
      buttonTitle: 'OK',
    },
    addressIsPOB: {
      isModal: false,
    },
  },
  [ActionTypes.ActionCreateCheckoutPurchase]: {
    ageRestriction: {
      isModal: true,
      title: '',
      description: 'You must be at least 18 in order to apply for financing',
      buttonTitle: 'OK',
      cancelApplication: true,
    },
    ageRestriction19: {
      isModal: true,
      title: '',
      description: 'You must be at least 19 in order to apply for financing',
      buttonTitle: 'OK',
      cancelApplication: true,
    },
    leftMaxAmountsBeforeTaxErrorCode: {
      isModal: true,
      description:
        'You have used your full approval amount, so we cannot approve your application at this time. You will receive an email providing you with more information.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    onlineCancellationErrorCode: {
      isModal: true,
      title: 'Unfortunately, your application cannot be approved at this time',
      description: `You will receive an email with more information.`,
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    ofacPendingError: {
      isModal: true,
      description: `We are verifying your information. Please contact us at ${phoneNumber} if you have any questions.`,
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    ofacFinalError: {
      isModal: true,
      title: 'Unfortunately, your application cannot be approved at this time',
      description: `You will receive an email with more information.`,
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    ssnRequired: {
      isModal: true,
      description: 'Please enter your Social Security Number',
      buttonTitle: 'Update',
    },
    duplicateSSN: {
      isModal: true,
      description: 'Unfortunately, we are unable to verify your identity and cannot process your application.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    ssnVerificationFailedTooManyTimes: {
      isModal: true,
      description: 'Unfortunately, we are unable to verify your identity and cannot process your application.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    consumerAlert: {
      isModal: true,
      description:
        'Due to an alert on your consumer report, we are required to verify your identity before proceeding. Please contact us at 855-7-SUNBIT (855-778-6248). You will need to restart the Sunbit application after your identity has been confirmed.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
    ILLEGAL_ARGUMENT: {
      isModal: true,
      description: "The total amount is below Sunbit's minimum financing requirement. \n Please update your amount and try again.",
      buttonTitle: 'Close',
      cancelApplication: false,
    },
    numberOfAllowedActiveLoansExceeded: {
      description: 'Hawaiian customers must wait three days after their existing loan before applying for financing',
      isModal: true,
      buttonTitle: 'OK',
      cancelApplication: true,
    },
    [ErrorCodes.extraVerificationRequired]: {
      isModal: true,
      description:
        'Unfortunately, we are unable to approve your application at this time. You will receive a detailed notice via email with additional details.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
  },
  [ActionTypes.ActionValidateDebitCard]: {
    'rejectionErrorCode:140': {
      // wrongCardType - pre-paid
      isModal: true,
      title: "It looks like you're using a pre-paid debit card",
      description: 'Please use a valid, bank-issued debit card.',
      buttonTitle: 'OK',
    },
    'rejectionErrorCode:6': {
      // wrongCardType - credit-card
      isModal: true,
      title: "It looks like you're using a credit card",
      description: 'Please use a valid, bank-issued debit card.',
      buttonTitle: 'OK',
    },
    'rejectionErrorCode:2': {
      // wrong card type or canceled ?
      isModal: true,
      title: 'This card was declined by issuer',
      description: 'Please use a valid, bank-issued debit card.',
      buttonTitle: 'OK',
    },
    'rejectionErrorCode:145': {
      // invalid card number
      isModal: true,
      title: 'Invalid Card',
      description: 'Please use valid bank-issued debit card details',
      buttonTitle: 'OK',
    },
    'rejectionErrorCode:160': {
      // couldNotVerifyCardByHold
      isModal: true,
      title: 'Invalid Card',
      description: 'Please use valid bank-issued debit card details',
      buttonTitle: 'OK',
    },
    'CancellationErrorCode:6': {
      // wrong card type or canceled ?
      isModal: true,
      title: 'Invalid Card',
      description: 'Please use valid bank-issued debit card details',
      buttonTitle: 'OK',
    },
    'rejectionErrorCode:165': {
      // invalid cvv
      isModal: true,
      title: 'Invalid Card',
      description: 'Please use valid bank-issued debit card details',
      buttonTitle: 'OK',
    },
    InvalidRoutingNumber: {
      isModal: true,
      description: 'Please enter a valid 9-digit routing number',
      buttonTitle: 'OK',
    },
    'CancellationErrorCode:210': {
      // exceedRequestCount
      isModal: true,
      description:
        'We only accept valid bank-issued debit cards. You will receive further communication via email. If you have any questions, please call us at 855.778.6248.',
      buttonTitle: 'close',
      cancelApplication: true,
    },
    [ErrorCodes.extraVerificationRequired]: {
      isModal: true,
      description:
        'Unfortunately, we are unable to approve your application at this time. You will receive a detailed notice via email with additional details.',
      buttonTitle: 'Close',
      cancelApplication: true,
    },
  },
  [ActionTypes.ActionVerifySSN]: {
    ssnNotValid: {
      isModal: true,
      description: "Details don't match. Please try again.",
      buttonTitle: 'Update',
    },
    'CancellationErrorCode:22': {
      isModal: true,
      description:
        'Unfortunately we are unable to verify your identity and cannot process your application at this time. You will receive an email with more information.' +
        '<br><br>' +
        'For help, contact support  at (855) 778-6248<br>' +
        'Mon-Fri, 4am-9pm; Sat, 6am-8pm; Sun, 6am-6pm (Pacific Time)',
      buttonTitle: 'Close',
      cancelApplication: true,
      cancelationReason: CancelationReasons.SsnNotVerified,
    },
    emailNotVerified: {
      isModal: true,
      description: 'Please verify your email address', //TODO: I don't see it on the error list
      buttonTitle: 'Close',
    },
  },
};

export const fallbackError = {
  title: 'Technical Error',
  description: `Due to a technical error we are unable to process your application. If the problem persists, please contact Customer Support at ${phoneNumber}`,
  buttonTitle: 'Close',
  isModal: true,
  cancelApplication: true,
  cancelationReason: CancelationReasons.TechnicalIssue,
};
